// ==================about-us===========================

  document.documentElement.scrollTop = 0;
  let windowWidth = $(window).width();
  let ballOfTopWindow = $(window).width() * 0.23; // жестко задал (для мобильного)
  let youngHandHeight = $(".about-us__young-hand-all").height(); // ВЫСОТА РУКИ
  let ballHeight = $(".about-us__clew").height(); // ВЫСОТА КЛУБКА
  let windowHeight = isMobile.any() ? window.screen.height : $(window).height(); // ВЫСОТА ЭКРАНА
  let blokFirstHeight = $(".about-us__first-animate-blok").height(); // ВЫСОТА Блока Первого
  let handCenter = youngHandHeight * 0.4;
  let clewTarget;
  let titleTarget;
  let oldHandTarget;
  let oldHandRotate;
  let youngHandMove;
  let youngHandRotate;

  function updateAboutUs() {
   
    $(".about-us__clew").attr("style", "");
    $(".about-us__old-hand-all").attr("style", "");
    $(".about-us__old-hand-fingers").attr("style", "");
    ballOfTopWindow = $(".about-us__clew").position().top; // РАССТОЯНИЕ от КЛУБКА до верха окна
    youngHandHeight = $(".about-us__young-hand-all").height(); // ВЫСОТА РУКИ
    ballHeight = $(".about-us__clew").height(); // ВЫСОТА КЛУБКА
    windowHeight = isMobile.any() ? window.screen.height : $(window).height();// ВЫСОТА ЭКРАНА
    blokFirstHeight = $(".about-us__first-animate-blok").height(); // ВЫСОТА Блока Первого
    handCenter = youngHandHeight * 0.4;
    document.documentElement.scrollTop = 0;
  }
  if (!isMobile.any()) {
    ballOfTopWindow = $(".about-us__clew").position().top; // РАССТОЯНИЕ от КЛУБКА до верха окна
    window.onresize = function () {
      updateAboutUs();
    };
  } else {
    window.onresize = function () {
      if (windowWidth !== $(window).width()) {
        updateAboutUs();
        windowWidth = $(window).width();
      }
    };
  }
  $(window).scroll(function (e) {
    moveAboutUs(e);
  });
  function moveAboutUs(e) {
    let scrollingTop = e.currentTarget.pageYOffset || $(window).scrollTop(); // СКРОЛЛ ОТ ВЕРХА
    let containerHeight = $(".about-us").height(); // ВЫСОТА СТРАНИЦЫ
    let scrollPercent = scrollingTop / (containerHeight - windowHeight);
    var clewOfTop = $(".about-us__clew").position().top;
    let howFarDidTheClew = ballOfTopWindow - clewOfTop;
    let scrollPercentFirst = scrollingTop / (blokFirstHeight - $(".about-us__clew").position().top); // scrollingTop / (blokFirstHeight - document.querySelector(".about-us__clew").getBoundingClientRect().top)
    let scrollPercentOut = Math.abs((containerHeight - windowHeight - scrollingTop) / windowHeight); // Процент скролла после Контейнера
    let clewDeg = 290 * containerHeight / $(window).width();

    // ============================================
    //  +++++++++++++++++ title ++++++++++++++++++++
    if (scrollPercent => 0 && scrollPercent > 0.2) {
      titleTarget = (windowHeight - containerHeight / 1.4) * scrollPercent;
      $(".about-us__title").css({
        transform: `translateY(${titleTarget}px) `,
        opacity: 1
      });
    }
    if (scrollPercent > 0.2) {
      $(".about-us__title").css({
        transform: `translateY(${titleTarget}px) `,
        opacity: 0
      });
    }

    // ============================================
    //  +++++++++++++++++ clew ++++++++++++++++++++

    if (scrollPercent === 0) {
      $(".about-us__clew").css({
        position: "relative",
        transform: `translateX(-50%) translateY(0px) `,
        transition: "none"
      });
      $(".about-us__clew-wrapper").css({
        top: "0"
      });
    }
    if (scrollPercent > 0 && scrollPercent <= 0.5) {
      $(".about-us__clew").css({
        opacity: `${1 - scrollPercent}`
      });
    }
    if (scrollPercent > 0.5 && scrollPercent <= 1) {
      $(".about-us__clew").css({
        opacity: `${0 + scrollPercent}`
      });
    }
    if (scrollPercent > 0 && scrollPercent <= 1) {
      clewTarget = (windowHeight - handCenter - ballHeight - ballOfTopWindow) * scrollPercent;
      $(".about-us__clew").css({
        position: "fixed",
        transform: `translateX(-50%) translateY(${clewTarget}px) `,
        transition: "top 0.5s ease-out"
      });
    }
    if (scrollPercent > 1) {
      $(".about-us__clew").css({
        transform: `translateX(-50%) translateY(${0}px) `,
        position: "relative",
        top: `${ballOfTopWindow}px`,
        transition: "top 0.5s ease-out"
      });
      $(".about-us__clew-wrapper").css({
        top: "initial"
      });
    }
    if (scrollPercentFirst > 0 & scrollPercentFirst < 0.5) {
      $(".about-us__clew").css({
        left: `calc(50% + 1vw - ${2 * scrollPercentFirst}vw) `
      });
    }

    // ============================================
    //  +++++++++++++++++ clew img ++++++++++++++++++++
    if (scrollPercent > 0 && scrollPercent <= 1.001) {
      $(".about-us__clew-img").css({
        transform: `rotate(-${clewDeg * scrollPercent}deg) `
      });
    }

    // ============================================
    //  ++++++++++++++ young-hand +++++++++++++++++
    if (scrollPercent > 0 && scrollPercent < 1) {
      youngHandMove = 70 * scrollPercent;
      youngHandRotate = 110 - 110 * scrollPercent;
      $(".about-us__young-hand-all").css({
        transform: `translateX(${youngHandMove}vw) rotate(${youngHandRotate}deg)`,
        transition: "none"
      });
      $(".about-us__young-hand-fingers").css({
        transform: `translateX(${youngHandMove}vw) rotate(${youngHandRotate}deg)`,
        transition: "none"
      });
    }
    if (scrollPercent >= 1) {
      $(".about-us__young-hand-all").css({
        transform: `translateX(70vw) rotate(0deg)`,
        transition: "transform 0.2s ease-out"
      });
      $(".about-us__young-hand-fingers").css({
        transform: `translateX(70vw) rotate(0deg)`,
        transition: "transform 0.2s ease-out"
      });
    }

    // ============================================
    //  +++++++++++++++ old-hand ++++++++++++++++++

    if (scrollPercentFirst => 0 && scrollPercentFirst < 0.5) {
      oldHandTarget = (windowHeight / blokFirstHeight - ballHeight - ballOfTopWindow) * scrollPercentFirst;
      oldHandRotate = -85 * scrollPercentFirst;
      $(".about-us__old-hand-all").css({
        transform: `translateY(${oldHandTarget - howFarDidTheClew}px)
                      translateX(${4 * scrollPercentFirst}vw) rotateZ(${oldHandRotate}deg)`,
        opacity: 1,
        transition: "none"
      });
      $(".about-us__old-hand-fingers").css({
        transform: `translateY(${oldHandTarget - howFarDidTheClew}px)
                      translateX(${4 * scrollPercentFirst}vw) rotateZ(${oldHandRotate}deg)`,
        opacity: 1,
        transition: "none"
      });
    }
    if (scrollPercentFirst >= 0.5 && scrollPercentFirst <= 1.1) {
      $(".about-us__old-hand-all").css({
        transform: `translateY(${oldHandTarget - howFarDidTheClew + -($(window).width() / 2.72) * (scrollPercentFirst - 0.5)}px)
                      translateX(${4 * scrollPercentFirst + 40 * (scrollPercentFirst - 0.5)}vw) rotateZ(${oldHandRotate - (scrollPercentFirst - 0.5)}deg)`,
        opacity: 1 - (scrollPercentFirst - 0.5),
        transition: "none"
      });
      $(".about-us__old-hand-fingers").css({
        transform: `translateY(${oldHandTarget - howFarDidTheClew + -($(window).width() / 2.72) * (scrollPercentFirst - 0.5)}px)
                      translateX(${4 * scrollPercentFirst + 40 * (scrollPercentFirst - 0.5)}vw) rotateZ(${oldHandRotate - (scrollPercentFirst - 0.5)}deg)`,
        opacity: 1 - (scrollPercentFirst - 0.5),
        transition: "none"
      });
    }
    if (scrollPercentFirst > 1.1) {
      $(".about-us__old-hand-all").css({
        opacity: 0,
        transition: "none"
      });
      $(".about-us__old-hand-fingers").css({
        opacity: 0,
        transition: "none"
      });
    }
    //  ++++++++++++++++++++++++++++++++++++++++++
  }

